(function(){
    const $body = $("body");
    var offset = 0;
    var lastPosition = 0;
    var ticking = false;
    $body.addClass('scroll-top');
    function onScroll(lastPosition) {
        // var height = window.innerHeight/2;
        var height = 0;
        if (lastPosition > height) {
            if (lastPosition > offset) {
                $body.addClass('scroll-bottom');
                $body.removeClass('scroll-top');
            } else {
                $body.removeClass('scroll-bottom');
                $body.addClass('scroll-top');
            }
            offset = lastPosition;
        }
    }
    function tickingFlg(){
        clearTimeout( timeoutId ) ;
        $body.removeClass('scroll-stop').addClass('scrolling');
        lastPosition = window.pageYOffset;
        if (!ticking) {
            window.requestAnimationFrame(function() {
                onScroll(lastPosition);
                ticking = false;
            });
            ticking = true;
        }
        timeoutId = setTimeout( function () {
            $body.removeClass('scrolling').addClass('scroll-stop');
    	}, 500 ) ;
    }

    var timeoutId ;
    window.addEventListener('scroll', tickingFlg, { passive: false });

})();
